import OktaAuth from "@okta/okta-auth-js";
import { OktaAuthConfig } from "./types";
import { accountAuthConfig, getOktaAccountAuthObject } from "./account";
import { institutionalAuthConfig } from "./institutional";
import { preferencesAuthConfig } from "./preferences";

export const getOktaAuthObject = (authConfig: OktaAuthConfig) => {
  const { clientId, issuer, redirectUri } = authConfig;

  return new OktaAuth({
    issuer,
    clientId,
    redirectUri: `${window.location.origin}${redirectUri}`,
    scopes: ["email", "openid", "profile"],
    tokenManager: {
      autoRenew: true,
      storage: "sessionStorage",
      storageKey: `${clientId.slice(-6)}-token-storage`,
    },
  });
};

export const getSessionAndTokens = async (oktaAuth: OktaAuth) => {
  try {
    const sessionExists = await oktaAuth.session.exists();

    if (!sessionExists) {
      console.log("Session does not exist");
      return;
    }

    const tokens = await oktaAuth.token.getWithoutPrompt({
      responseType: ["token", "id_token"],
      scopes: ["email", "openid", "profile"],
    });
    return tokens;
  } catch (error) {
    console.error("Error getting tokens: ", error);
    throw error;
  }
};

export const clearOktaAuths = async () => {
  const accountAuth = getOktaAccountAuthObject(accountAuthConfig);
  const institutionalAuth = getOktaAuthObject(institutionalAuthConfig);
  const preferencesAuth = getOktaAuthObject(preferencesAuthConfig);

  try {
    await Promise.all([
      clearOktaAuthInstance(accountAuth),
      clearOktaAuthInstance(institutionalAuth),
      clearOktaAuthInstance(preferencesAuth),
    ]);
  } catch (e) {
    console.error("Error clearing Okta auths: ", e);
    throw e;
  }

  return {
    accountAuth,
    institutionalAuth,
    preferencesAuth,
  };
};

export const clearOktaAuthInstance = async (oktaAuth: OktaAuth) => {
  try {
    await oktaAuth.revokeAccessToken();
    await oktaAuth.closeSession();
    await oktaAuth.clearStorage();
  } catch (e) {
    console.error("Error clearing Okta auth instance: ", e);
    throw e;
  }
};
